import type { AiModelsSettings } from "./settings-types.js";

/**
 * YAML fragment for ~/.hermes/config.yaml (merge manually; restart gateway).
 * Vision uses auxiliary.custom routing (base_url) which matches Hermes auxiliary_client.
 */
export function buildHermesYamlSnippet(ai: AiModelsSettings): string {
  const reasoning = (ai.reasoningModel || "").trim() || "deepseek/deepseek-chat";
  const vModel = (ai.visionModel || "").trim() || "gpt-4o";
  const vBase = (ai.visionOpenAIBaseUrl || "").trim().replace(/\/+$/, "") || "https://api.openai.com/v1";

  return `# --- EAD Explore UI — suggested Hermes fragment ---
# Merge into ~/.hermes/config.yaml (or include from a snippets file), then restart the gateway.
# Env in ~/.hermes/.env (examples):
#   DEEPSEEK_API_KEY=...     # required for main reasoning when using DeepSeek
#   OPENAI_API_KEY=...       # used for vision when api_key is omitted below

model: ${reasoning}

auxiliary:
  vision:
    provider: custom
    base_url: ${vBase}
    model: ${vModel}
    api_key: ""
`;
}
